import React from 'react';
import { IBadgeList } from './interfaces';
import { Chip, Stack, Tooltip } from '@mui/material';

export const BadgeList: React.FC<IBadgeList> = ({
  items,
  sx,
  maxItems = 2,
}): JSX.Element => {
  const visibleItems = items.slice(0, maxItems);
  const hiddenCount = items.length - visibleItems.length;

  const content = (
    <Stack direction="row" spacing={0.5} alignItems="center" sx={sx}>
      {visibleItems.map((item) => {
        const chip = (
          <Chip
            label={item.label}
            icon={item.icon}
            onClick={item.onClick}
            size="small"
            variant="outlined"
          />
        );

        return item.tooltip ? (
          <Tooltip key={item.label} title={item.tooltip}>
            <span>{chip}</span>
          </Tooltip>
        ) : (
          <React.Fragment key={item.label}>{chip}</React.Fragment>
        );
      })}

      {hiddenCount > 0 && (
        <Chip label={`+${hiddenCount}`} size="small" variant="outlined" />
      )}
    </Stack>
  );

  return hiddenCount > 0 ? (
    <Tooltip
      title={items
        .map((item) => item.tooltip ?? item.label)
        .join(', ')}
      enterDelay={500}
    >
      {content}
    </Tooltip>
  ) : (
    content
  );
};
